import { RgAffectsParentGeometry } from './rg-affects-parent-geometry.js';

const affectsParentGeo = (obj) => obj.parent && RgAffectsParentGeometry[obj.type].includes(obj.parent.type);

export { affectsParentGeo };
//# sourceMappingURL=affects-parent-geo.js.map
